"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("react-mdl/lib/Spinner"));

var _base = _interopRequireDefault(require("../../styles/base.scss"));

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    className: _base["default"].spinner
  });
};

exports["default"] = _default;